
// рандомное число в интервале от min до max включительно
export function randomInteger(min, max) {
    // случайное число от min до (max+1)
    let rand = min + Math.random() * (max + 1 - min);
    return Math.floor(rand);
}


// WEBPACK FOOTER //
// ./_src/js/util.js